const DEVICE_BUTTON_TYPE = {
  inBasket: 'inBasket',
  preOrder: 'preOrder',
  toBasket: 'toBasket',
};

const DEVICE_BUTTON_VARIANT = {
  [DEVICE_BUTTON_TYPE.inBasket]: 'secondary',
  [DEVICE_BUTTON_TYPE.preOrder]: 'main',
  [DEVICE_BUTTON_TYPE.toBasket]: 'main',
};

const DEVICE_BUTTON_CAPTION = {
  [DEVICE_BUTTON_TYPE.inBasket]: 'В корзине',
  [DEVICE_BUTTON_TYPE.preOrder]: 'Оформить предзаказ',
  [DEVICE_BUTTON_TYPE.toBasket]: 'В корзину',
};

export const devicePreviewPurchaseButtonDataHelper = ({ isInBasket, isPreorder }) => {
  let type = DEVICE_BUTTON_TYPE.toBasket;

  if (isInBasket) {
    type = DEVICE_BUTTON_TYPE.inBasket;
  }

  if (isPreorder) {
    type = DEVICE_BUTTON_TYPE.preOrder;
  }

  return {
    variant: DEVICE_BUTTON_VARIANT[type],
    title: DEVICE_BUTTON_CAPTION[type],
  };
};
